import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import UnitFiltersSection from "../../components/UnitFiltersSection";
import "../../styles/reviews.css";
import * as unitFiltersApi from "../../services/unit_filters";

function UnitFiltersPage() {
  const [unitFilters, setUnitFilters] = useState([]);
  const [loading, setLoading] = useState(true);
  const history = useHistory();

  useEffect(() => {
    fetchUnitFilters();
  }, []);

  const fetchUnitFilters = async () => {
    setLoading(true);
    try {
      const res = await unitFiltersApi.getUnitFilters();
      setUnitFilters(res.data);
    } finally {
      setLoading(false);
    }
  };

  const handleAdd = () => {
    history.push("/unit-filters/new");
  };
  const handleEdit = (idx) => {
    const unitFilter = unitFilters[idx];
    if (unitFilter) history.push(`/unit-filters/${unitFilter.id}`);
  };
  const handleDelete = async (idx) => {
    const unitFilter = unitFilters[idx];
    if (!unitFilter) return;
    if (window.confirm("Are you sure you want to delete this unit filter?")) {
      await unitFiltersApi.deleteUnitFilter(unitFilter.id);
      fetchUnitFilters();
    }
  };

  return (
    <div className="wrapper">
      <div className="container-fluid" style={{ padding: 10 }}>
        {loading ? (
          <div>Loading...</div>
        ) : (
          <UnitFiltersSection unitFilters={unitFilters} onAdd={handleAdd} onEdit={handleEdit} onDelete={handleDelete} />
        )}
      </div>
    </div>
  );
}

export default UnitFiltersPage;